import { render } from "./SyncMenuButton.vue?vue&type=template&id=526fe106"
import script from "./SyncMenuButton.vue?vue&type=script&lang=js"
export * from "./SyncMenuButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__